/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var list_component_1 = require("./list.component");
var searchbar_component_1 = require("./searchbar.component");
var taglist_component_1 = require("./taglist.component");
var kendo_angular_popup_1 = require("@progress/kendo-angular-popup");
var kendo_angular_common_1 = require("@progress/kendo-angular-common");
var shared_directives_module_1 = require("./shared-directives.module");
var list_item_directive_1 = require("./list-item.directive");
var selectable_directive_1 = require("./selection/selectable.directive");
var template_context_directive_1 = require("./templates/template-context.directive");
var check_directive_1 = require("../dropdowntrees/checked-state/check.directive");
var check_all_directive_1 = require("../dropdowntrees/checked-state/check-all.directive");
var INTERNAL_DIRECTIVES = [
    list_component_1.ListComponent,
    list_item_directive_1.ListItemDirective,
    selectable_directive_1.SelectableDirective,
    searchbar_component_1.SearchBarComponent,
    template_context_directive_1.TemplateContextDirective,
    taglist_component_1.TagListComponent,
    check_directive_1.CheckDirective,
    check_all_directive_1.CheckAllDirective
];
/**
 * @hidden
 */
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [INTERNAL_DIRECTIVES],
            exports: [INTERNAL_DIRECTIVES, common_1.CommonModule, forms_1.FormsModule, kendo_angular_popup_1.PopupModule, kendo_angular_common_1.ResizeSensorModule, shared_directives_module_1.SharedDirectivesModule, kendo_angular_common_1.EventsModule],
            imports: [common_1.CommonModule, forms_1.FormsModule, kendo_angular_popup_1.PopupModule, kendo_angular_common_1.ResizeSensorModule, shared_directives_module_1.SharedDirectivesModule, kendo_angular_common_1.EventsModule]
        })
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;
